
import classNames from 'classnames'

import styles from './title.module.sass'

import BlockWrapper from '../layout/block_wrapper'
import ScrollAnimation from '../layout/scroll_animation'

function Title(props) {

	const fields = props.fields

	const theme = props.theme || 'light'

	if (props.layout_settings && (fields.eyebrow || fields.title || fields.subtitle)) {
		return <BlockWrapper {...props} className={classNames(styles.title, styles[theme])}>
			<ScrollAnimation styles={styles} reverse={true}>
				{fields.heading_type == 'h1' &&
					<h1>
						{fields.eyebrow && <span className={classNames(styles.eyebrow, fields.eyebrow_text_color && fields.eyebrow_text_color != 'default' ? fields.eyebrow_text_color : '')}>{fields.eyebrow}</span>}
						{fields.title && <span className={styles.title} dangerouslySetInnerHTML={{__html: fields.title}}></span>}
						{fields.subtitle && <span className={styles.subtitle}>{fields.subtitle}</span>}
					</h1>
				}

				{fields.heading_type == 'h2' &&
					<h2>
						{fields.eyebrow && <span className={classNames(styles.eyebrow, fields.eyebrow_text_color && fields.eyebrow_text_color != 'default' ? fields.eyebrow_text_color : '')}>{fields.eyebrow}</span>}
						{fields.title && <span className={styles.title} dangerouslySetInnerHTML={{__html: fields.title}}></span>}
						{fields.subtitle && <span className={styles.subtitle}>{fields.subtitle}</span>}
					</h2>
				}

				{fields.divider && fields.title &&
					<hr />
				}
			</ScrollAnimation>
		</BlockWrapper>
	} else if(fields.eyebrow || fields.title || fields.subtitle) {
		return <div className={classNames(styles.title, styles[theme], fields.className)}>
			{fields.heading_type == 'h1' &&
				<h1>
					{fields.eyebrow && <span className={classNames(styles.eyebrow, fields.eyebrow_text_color && fields.eyebrow_text_color != 'default' ? fields.eyebrow_text_color : '')}>{fields.eyebrow}</span>}
					{fields.title && <span className={styles.title} dangerouslySetInnerHTML={{__html: fields.title}}></span>}
					{fields.subtitle && <span className={styles.subtitle}>{fields.subtitle}</span>}
				</h1>
			}

			{fields.heading_type == 'h2' &&
				<h2>
					{fields.eyebrow && <span className={classNames(styles.eyebrow, fields.eyebrow_text_color && fields.eyebrow_text_color != 'default' ? fields.eyebrow_text_color : '')}>{fields.eyebrow}</span>}
					{fields.title && <span className={styles.title} dangerouslySetInnerHTML={{__html: fields.title}}></span>}
					{fields.subtitle && <span className={styles.subtitle}>{fields.subtitle}</span>}
				</h2>
			}

{			fields.divider && fields.title &&
				<hr />
			}
		</div>
	}

}

export default Title